import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
export const Skeleton = ({ className, ...rest }) => (_jsx("div", { "aria-hidden": "true", className: cn('animate-pulse rounded-md bg-muted', className), ...rest }));
//# sourceMappingURL=skeleton.js.map